import { AppHelper } from "../appHelper"
import { Grid } from "../core/components/grid";
import { ToolBarStandardButton, ToolBarStandardButtonType } from "../core/components/toolBar";
import { AppBaseProps, CommonApp } from "../core/components/commonApp";
import { Helper } from "../core/util/helper";
import { Config } from "../core/config/config";
import { HTTPService} from "../core/util/httpManager";
import { NotificationHelper } from "../core/util/notificationHelper";
import { StringKeyDictionary } from "../commonInterfaces";
import React from "react";
export class GeocodeDataApp extends React.Component<AppBaseProps, GeocodeDataAppState> {
    private _geocodeGridData: Array<any> = [];
    private _geocodeGridRef: Grid;
    common = new AppHelper();
    setTabTitle = true;
    translations: StringKeyDictionary<string>;
    geocodeGridOptions: kendo.ui.GridOptions;
    private _selItem: any = null;

    constructor(props) {
        super(props);
        this.state = { selectedId: null }//, selectedIsguid: null}
        this.common.enableHooks = true;
        this.common.init(this);
        this._refresh();
    }

    private _refresh = () => {
        return HTTPService.get("Geocode/GetGeodata")
            .then(result => {
                Helper.setArrayValues(this._geocodeGridData, result.Data);
                this.setState({});
            });
    }

    private _edit = (dataItem) => {
        var url = dataItem.Tablename == "VKUNADR"
            ? "Address/Edit?id=" + encodeURIComponent(dataItem.Id)
            :  dataItem.Tablename == "RESSLIST" ? "Resource/Edit?id=" + encodeURIComponent(dataItem.Id) :
                "Machine/Edit?id=" + encodeURIComponent(dataItem.Id);
      
        window.open((Config.baseUrl + url), '_blank');
    }

    private _handleClickStandardButton = (type: ToolBarStandardButtonType, dataItem) => {
        if (type == ToolBarStandardButtonType.RELOAD)
            this._refresh();
        if (type == ToolBarStandardButtonType.EDIT)
            this._edit(dataItem);
        if (type == ToolBarStandardButtonType.DELETE)
            this._delete(dataItem.GeodataId);
    }

    private _handleSelectionChanged = (dataItem: any) => {
        if (Helper.hasValue(dataItem)) {
            this.setState({selectedId: dataItem.Id });//, selectedIsguid: dataItem.Isguid })
        } else
            this.setState({selectedId: null });//, selectedIsguid: null });
    }
    
    private _delete(geodataId) {
        return HTTPService.post("Geocode/Delete?Isguid="+ encodeURIComponent(geodataId))
            .then(result => {
                NotificationHelper.showSuccessMessage(this.translations["WebSMS.Geodata.GeodataDeleted"]);
                this._refresh();
            });
    }

    createGrid = () => {
        let tbButtons: Array<ToolBarStandardButton> = [];
        
        const statusEnabled = this.state.selectedId != null;// && this.state.selectedId == this.state.selectedIsguid;

        tbButtons.push({ type: ToolBarStandardButtonType.RELOAD, caption: Config.translations.reloadLabel, enabled: true });
        tbButtons.push({ type: ToolBarStandardButtonType.EDIT, caption: Config.translations.editLabel, enabled: statusEnabled });
        tbButtons.push({ type: ToolBarStandardButtonType.DELETE, caption: this.translations["WebSMS.Geodata.StatusZureucksetzen"], enabled: statusEnabled });

       
        return (
            <div className="flex-container">
                    <Grid data={this._geocodeGridData} 
                          options={this.geocodeGridOptions} id="geocodeGrid"
                          ref={(r) => this._geocodeGridRef = r}
                          onSelectionChanged={this._handleSelectionChanged}
                          standardButtons={tbButtons}
                          onClickStandardButton={this._handleClickStandardButton}
                       />
            </div>
        );
    }

    render() {
        const props = $.extend({}, this.props, this.common.getHandlersForProps());
        return <CommonApp {...props} />;
    }
};

interface GeocodeDataAppState {
    selectedId: string;
    //selectedIsguid: string;
}

